// GENERATED by scripts/update-version.sh — do not edit by hand.
// Re-run that script (or bump a git tag) and rebuild to change these values.
export const APP_VERSION = "b0c1d98";
export const BUILD_DATE = "2026-11-02";
export const BUILD_COMMIT = "b0c1d98";
